// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.container-cards {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    width: 400px;
    height: 330px;
    transition: 0.3s;
    border: 1px solid #ccc;
    border-radius: 12px;
    padding: 5px 10px;
    margin: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    color: var(--cDark)
}


.container-cards:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);

}

.item {
    display: grid;
    grid-template-columns: 40% 60%;
    column-gap: 5px;
padding: 3px;
}


.chave {
    font-weight: bold;
}



.titulo{
    color: var(--aiAzul);
    margin-left: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/card/card-style.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,0CAA0C;IAC1C;AACJ;;;AAGA;IACI,2CAA2C;;AAE/C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB,YAAY;AACZ;;;AAGA;IACI,iBAAiB;AACrB;;;;AAIA;IACI,oBAAoB;IACpB,iBAAiB;AACrB","sourcesContent":["\n.container-cards {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    width: 400px;\n    height: 330px;\n    transition: 0.3s;\n    border: 1px solid #ccc;\n    border-radius: 12px;\n    padding: 5px 10px;\n    margin: 10px;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n    color: var(--cDark)\n}\n\n\n.container-cards:hover {\n    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n\n}\n\n.item {\n    display: grid;\n    grid-template-columns: 40% 60%;\n    column-gap: 5px;\npadding: 3px;\n}\n\n\n.chave {\n    font-weight: bold;\n}\n\n\n\n.titulo{\n    color: var(--aiAzul);\n    margin-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
